import { createSlice } from '@reduxjs/toolkit';
import reducerTypes from '../reducerTypes';
import MyProfileHelper from '../../helpers/features/MyProfileHelper';
import common from '../../helpers/common';

const initialState = {
    isSidePanelOpen: false,
    activeTab: MyProfileHelper.PROFILE_SIDEPANEL_TABS.GENERAL.KEY,
    currentRegulationType: "1",
    currentUserPlan: null,
    subscriptionPlans: {
        [MyProfileHelper.SUBSCRIPION_PLANS.MONTHLY] : [],
        [MyProfileHelper.SUBSCRIPION_PLANS.YEARLY] : []
    },
    showSubscriptionCards: {
        [common.REG_TABS[0].id]:  false,
        [common.REG_TABS[1].id]:  false,
    },
    user:{}
};

export const profileSlice = createSlice({
    name: reducerTypes.profile,
    initialState,
    reducers: {
        OPEN_PROFILE_SIDE_PANEL: (state, data) => {
            state.isSidePanelOpen = true;
        },
        CLOSE_PROFILE_SIDE_PANEL: (state, data) => {
            state.isSidePanelOpen = false;
        },
        SET_CURRENT_TAB: (state, data) => {
            state.activeTab = data.payload;
        },
        SET_CURRENT_REGULATION_TYPE: (state, data) => {
            state.currentRegulationType = data.payload;
        },
        SET_SUBSCRIPTION_PLANS: (state, data) => {
            state.subscriptionPlans[data.payload.period] = data.payload.plans;
        },
        SHOW_SUBSCRIPTION_CARDS: (state, data) => {
            state.showSubscriptionCards[data.payload.type] = data.payload.show;
        },
        SET_USER_PLAN: (state, data) => {
            state.currentUserPlan = data.payload.type;
        },
        SET_USER: (state, data) => {
            state.user = data.payload;
        },
    },
});

export const { OPEN_PROFILE_SIDE_PANEL, CLOSE_PROFILE_SIDE_PANEL, SET_CURRENT_TAB, SET_CURRENT_REGULATION_TYPE, SET_SUBSCRIPTION_PLANS, SHOW_SUBSCRIPTION_CARDS, SET_USER_PLAN, SET_USER } = profileSlice.actions;

export default profileSlice.reducer;
